import axios from 'axios';
import React, { Component } from 'react';
import { Button, Modal, Panel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { SET_APP_MENU } from 'actions/const';

import {
	IS_EMPTY_STRING,
	IS_LENGTH_ZERO,
	IS_NULL,
	IS_UNDEFINED,
	IS_VALID,
	RETRIEVE_ALL,
} from 'utils';
import saveTrail from 'utils/saveTrail';

import CrudComponent from '../zynappse-crud';
import AppMenuSchema from './AppMenuSchema';
import FormContainer from './FormContainer';

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class AppMenu extends Component {
	constructor(props) {
		super(props);

		this.refreshTableReference;

		this.saveData = this.saveData.bind(this);
		this.refreshTable = this.refreshTable.bind(this);
		this.getRelation = this.getRelation.bind(this);
		this.deleteData = this.deleteData.bind(this);
		this.getAppMenuConfig = this.getAppMenuConfig.bind(this);
		this.saveAppMenuConfig = this.saveAppMenuConfig.bind(this);
		this.loadOptions = this.loadOptions.bind(this);
		this.renderModalButton = this.renderModalButton.bind(this);
		this.accessible = this.accessible.bind(this);
		this.uploadSpecificUserCSVFile = this.uploadSpecificUserCSVFile.bind(this);
	}

	saveData() {
		let { AppMenu, actions } = this.props;

		let {
			selectedData,
			formType,
			formId,

			name,
			label,
			isEpicMillions,
			url,
			browser,
			isUseGoogleChrome,
			icon,
			isNew,
			position,
			sort,
			cardType,
			excludedCardType,
			specificUser,
			blacklistedUser,
			deviceType,
			isUploadingCSVFile,
			isUploadingCSVFileBlacklistedUser,
		} = AppMenu;

		if (!IS_VALID(name) || !IS_VALID(name.trim())) {
			toast.error('Name is required.');
		} else if (!IS_VALID(label) || !IS_VALID(label.trim())) {
			toast.error('Label is required.');
		} else if (!IS_VALID(browser) || !IS_VALID(browser.value)) {
			toast.error('Browser is required.');
		} else if (!IS_VALID(url) || !IS_VALID(url.trim())) {
			toast.error('URL is required.');
		} else if (!IS_VALID(position) || !IS_VALID(position.value)) {
			toast.error('Position is required.');
		} else if (!IS_VALID(sort)) {
			toast.error('Sort is required.');
		} else if (IS_LENGTH_ZERO(cardType) && IS_LENGTH_ZERO(specificUser)) {
			toast.error('You must provide either Card Type or Specific User.');
		} else {
			actions.setValue({
				isLoadingAction: true,
			});

			let fd = new FormData();

			fd.append('userId', Parse.User.current().id);
			fd.append('name', name);
			fd.append('label', label);
			fd.append('isEpicMillions', isEpicMillions);
			fd.append('url', url);
			fd.append('browser', browser.value);
			fd.append('isUseGoogleChrome', isUseGoogleChrome);
			fd.append('isNew', isNew);
			fd.append('position', position.value);
			fd.append('sort', sort);

			if (icon && icon.preview) {
				fd.append('icon', icon);
			} else if (!icon) {
				fd.append('isIconChanged', true);
			}

			if (IS_VALID(cardType) && Array.isArray(cardType) && specificUser.length === 0) {
				for (let index in cardType) {
					fd.append(`cardTypeIdArray[${index}]`, cardType[index].value || '');
				}
			}

			if (IS_VALID(excludedCardType) && Array.isArray(excludedCardType)) {
				for (let index in excludedCardType) {
					fd.append(
						`excludedCardTypeIdArray[${index}]`,
						excludedCardType[index].value || ''
					);
				}
			}

			if (IS_VALID(deviceType)) {
				fd.append(`deviceType`, deviceType.value);
			}

			if (IS_VALID(specificUser) && Array.isArray(specificUser) && cardType.length === 0) {
				for (let index in specificUser) {
					fd.append(`specificUserIdArray[${index}]`, specificUser[index].value || '');
				}
			}
			if (IS_VALID(blacklistedUser) && Array.isArray(blacklistedUser)) {
				for (let index in blacklistedUser) {
					fd.append(
						`blacklistedUserIdArray[${index}]`,
						blacklistedUser[index].value || ''
					);
				}
			}

			let httpMethod = 'post',
				_url = `${WEB_PATH}/AppMenu`;

			if (
				!IS_EMPTY_STRING(formType) &&
				formType.toUpperCase() === 'UPDATE' &&
				!IS_EMPTY_STRING(formId)
			) {
				httpMethod = 'put';
				_url = `${_url}/${formId}`;
			}

			axios[httpMethod](_url, fd)
				.then((res) => {
					let { data, changesObject } = res.data;

					actions.setValue({
						isLoadingAction: false,
						showModal: false,
					});

					this.refreshTable();

					saveTrail(formType.toUpperCase(), changesObject);
				})
				.catch((err) => {
					console.log('saveData error');
					console.log(err);

					actions.setValue({
						isLoadingAction: false,
						showModal: false,
					});

					this.refreshTable();
				});
		}
	}

	refreshTable() {
		if (IS_VALID(IS_VALID) && typeof this.refreshTableReference === 'function') {
			this.refreshTableReference();
		}
	}

	getRelation() {
		let { AppMenu, actions } = this.props;

		let { selectedData } = AppMenu;

		let cardTypeRelationQuery = selectedData.relation('CardType').query();
		let excludedCardTypeRelationQuery = selectedData.relation('ExcludedCardType').query();
		let specificUser = selectedData.relation('SpecificUser').query();
		let blacklistedUser = selectedData.relation('ExcludedUser').query();

		cardTypeRelationQuery.ascending('name');
		excludedCardTypeRelationQuery.ascending('name');
		specificUser.ascending('name');
		blacklistedUser.ascending('name');

		return Promise.all([
			cardTypeRelationQuery.find(),
			excludedCardTypeRelationQuery.find(),
			RETRIEVE_ALL(specificUser),
			RETRIEVE_ALL(blacklistedUser),
		]);
	}

	deleteData() {
		let { AppMenu, actions } = this.props;

		let { selectedData } = AppMenu;

		actions.setValue({ isLoadingAction: true });

		selectedData
			.destroy()
			.then((data) => {
				actions.setValue({
					isLoadingAction: false,
					showModal: false,
				});

				this.refreshTable();

				saveTrail('DELETE', {
					objectId: selectedData.id,
					name: selectedData.get('name') || '',
					label: selectedData.get('label') || '',
					url: selectedData.get('url') || '',
					browser: selectedData.get('browser') || '',
					isUseGoogleChrome: selectedData.get('isUseGoogleChrome') || false,
					new: selectedData.get('new') || false,
					position: selectedData.get('position') || false,
					sort: selectedData.get('sort') || false,
					icon: selectedData.get('icon') ? selectedData.get('icon').url() : '',
				});
			})
			.catch((err) => {
				console.log('deleteData error');
				console.log(err);

				actions.setValue({
					isLoadingAction: false,
					showModal: false,
				});

				this.refreshTable();
			});
	}

	getAppMenuConfig() {
		let { actions } = this.props;

		actions.setValue({
			isLoadingConfig: true,
		});

		let appMenuQuery = new Parse.Query('AppMenuConfig');

		appMenuQuery.equalTo('name', 'APP').descending('createdAt');

		appMenuQuery
			.first()
			.then((data) => {
				let stateToUpdate = {
					isLoadingConfig: false,
				};

				if (IS_VALID(data)) {
					stateToUpdate.isActive = IS_VALID(data.get('isActive'))
						? data.get('isActive')
						: true;
					stateToUpdate.appMenuConfig = data;
				} else {
					stateToUpdate.isActive = true;
				}

				actions.setValue(stateToUpdate);
			})
			.catch((err) => {
				console.log('getAppMenuConfig error');
				console.log(err);

				actions.setValue({
					isLoadingConfig: false,
				});
			});
	}

	saveAppMenuConfig() {
		let { AppMenu, actions } = this.props;

		let { isActive, appMenuConfig } = AppMenu;

		actions.setValue({ isSavingConfig: true });

		new Promise((resolve, reject) => {
			if (IS_VALID(appMenuConfig)) {
				resolve(appMenuConfig);
			} else {
				let query = new Parse.Query('AppMenuConfig');

				query.equalTo('name', 'APP').descending('createdAt');

				query.first().then(resolve).catch(reject);
			}
		})
			.then((appMenuConfig) => {
				if (IS_UNDEFINED(appMenuConfig)) {
					appMenuConfig = new Parse.Object('AppMenuConfig');

					appMenuConfig.set('name', 'APP');
				}

				appMenuConfig.set('isActive', !isActive);

				return appMenuConfig.save();
			})
			.then((appMenuConfig) => {
				let stateToUpdate = {
					isSavingConfig: false,
					isActive: !isActive,
					showModalConfig: false,
					appMenuConfig,
				};

				actions.setValue(stateToUpdate);

				saveTrail(isActive ? 'DEACTIVATE' : 'ACTIVATE', {
					isActive: !isActive,
				});
			})
			.catch((err) => {
				console.log('saveAppMenuConfig error');
				console.log(err);

				actions.setValue({
					isSaving: false,
					showModalConfig: false,
				});
			});
	}

	loadOptions(input, cb, className, columnName, sortColumn = columnName) {
		let query,
			objectItem = (item) => {
				let json = {
					label: item.get(columnName),
					value: item.id,
				};

				if (className === 'VoucherValidityType' || className === 'VoucherType') {
					json.shortName = item.get('shortName');
				}

				return json;
			};

		if (className === 'MemberDetail') {
			let query1 = new Parse.Query(className),
				query2 = new Parse.Query(className);

			query1.matches('memberId', input, 'i');

			query2.matches('name', input, 'i');

			query = Parse.Query.or(query1, query2);

			query.exists('memberId');
			query.notEqualTo('memberId', '');

			query.ascending('name');

			objectItem = (item) => {
				return {
					label: `${IS_VALID(item.get('memberId')) ? item.get('memberId') : ''} ${
						IS_VALID(item.get('name')) ? item.get('name') : ''
					}`,
					value: item.id,
				};
			};
		} else {
			query = new Parse.Query(className);

			query.matches(columnName, input.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'i');
			query.ascending(sortColumn);
		}

		query.limit(20);

		query
			.find()
			.then((data) => {
				return data.map(objectItem);
			})
			.then((data) => {
				cb(null, { options: data });
			})
			.catch((err) => {
				console.log('Load Select Options error: ', err.message);
			});
	}

	renderModalButton() {
		let { AppMenu, actions } = this.props;

		let { isLoadingAction, formType } = AppMenu;

		let buttons = [],
			buttonAction = (
				name = 'CREATE',
				loading = isLoadingAction,
				callback = this.saveData
			) => (
				<Button bsStyle="primary" disabled={loading} onClick={() => callback()}>
					{name}
				</Button>
			),
			buttonClose = (
				<Button
					disabled={isLoadingAction}
					onClick={() => {
						if (!isLoadingAction) {
							actions.setValue({
								showModal: false,
							});
						}
					}}
				>
					CLOSE
				</Button>
			);

		switch (formType.toUpperCase()) {
			case 'CREATE':
				buttons.push(buttonAction('CREATE', isLoadingAction), buttonClose);
				break;
			case 'UPDATE':
				buttons.push(buttonAction('UPDATE', isLoadingAction), buttonClose);
				break;
			case 'DELETE':
				buttons.push(buttonAction('DELETE', isLoadingAction, this.deleteData), buttonClose);
				break;
			default:
				buttons.push(buttonClose);
				break;
		}
		return buttons;
	}

	accessible(actionType) {
		let { access } = this.props.accessjson;

		if (access.length !== 0) {
			var currentPath = window.location.pathname,
				index = access
					.map((module) => module.route.toUpperCase())
					.indexOf(currentPath.toUpperCase()),
				actions = [];

			if (access[index]) {
				actions = access[index].actions;
			}

			if (actions.length != 0) {
				if (actions.indexOf(actionType.toUpperCase()) === -1) {
					return 'none';
				} else {
					return '';
				}
			} else {
				return 'none';
			}
		} else {
			return 'none';
		}
	}

	uploadSpecificUserCSVFile(csvFile, stateName) {
		let { AppMenu, actions } = this.props;

		let selectUserStateArray = AppMenu[stateName],
			loadingState =
				stateName === 'blacklistedUser'
					? 'isUploadingCSVFileBlacklistedUser'
					: 'isUploadingCSVFile';

		actions.setValue({
			[loadingState]: true,
		});

		let fd = new FormData();

		fd.append('csvFile', csvFile);

		axios
			.post(WEB_PATH + '/MemberDetail/upload', fd)
			.then((res) => {
				let { data } = res;

				let updatedUserArray = [...selectUserStateArray];

				for (let item of data) {
					if (updatedUserArray.map((item) => item.value).indexOf(item.objectId) === -1) {
						updatedUserArray.push({
							label: `${IS_VALID(item.memberId) ? item.memberId : ''} ${
								IS_VALID(item.name) ? item.name : ''
							}`,
							value: item.objectId,
						});
					}
				}

				actions.setValue({
					[loadingState]: false,
					[stateName]: updatedUserArray,
				});
			})
			.catch((err) => {
				console.log('uploadSpecificUserCSVFile error: ', err);

				actions.setValue({
					[loadingState]: false,
				});
			});
	}

	render() {
		let { AppMenu, accessjson, actions } = this.props;

		let {
			showModal,
			isLoadingAction,
			selectedData,
			formType,
			formTitle,

			showModalConfig,
			isSavingConfig,
			isLoadingConfig,
			isActive,
		} = AppMenu;

		let crudProps = {
			schema: AppMenuSchema,
			access: accessjson.access,
			moduleQuery: [{ method: 'descending', column: 'createdAt' }],
			saveTrail: saveTrail,
			customView: (obj) => {
				actions.setValue({
					showModal: true,
					formType: 'VIEW',
					formTitle: 'VIEW APP MENU',
					formId: obj.id,
					selectedData: obj,
				});
			},
			customCreate: () => {
				actions.setValue({
					showModal: true,
					formType: 'CREATE',
					formTitle: 'CREATE APP MENU',
				});
			},
			customUpdate: (obj) => {
				let stateToUpdate = {
					showModal: true,
					formType: 'UPDATE',
					formTitle: 'UPDATE APP MENU',
					formId: obj.id,
					selectedData: obj,
				};

				if (IS_VALID(obj.get('name'))) {
					stateToUpdate.name = obj.get('name');
				}

				if (IS_VALID(obj.get('label'))) {
					stateToUpdate.label = obj.get('label');
				}

				if (IS_VALID(obj.get('isEpicMillions'))) {
					stateToUpdate.isEpicMillions = obj.get('isEpicMillions');
				}

				if (IS_VALID(obj.get('url'))) {
					stateToUpdate.url = obj.get('url');
				}

				if (IS_VALID(obj.get('browser'))) {
					stateToUpdate.browser = {
						label:
							obj.get('browser').charAt(0).toUpperCase() +
							obj.get('browser').slice(1).toLowerCase(),
						value: obj.get('browser').toUpperCase(),
					};
				}

				if (IS_VALID(obj.get('isUseGoogleChrome'))) {
					stateToUpdate.isUseGoogleChrome = obj.get('isUseGoogleChrome');
				}

				if (IS_VALID(obj.get('position'))) {
					stateToUpdate.position = {
						label: 'Top',
						value: 'TOP',
					};
					// {
					//     label: obj.get("position").charAt(0).toUpperCase() + obj.get("position").slice(1).toLowerCase(),
					//     value: obj.get("position").toUpperCase()
					// };
				}

				if (IS_VALID(obj.get('sort'))) {
					stateToUpdate.sort = obj.get('sort');
				}

				if (IS_VALID(obj.get('new'))) {
					stateToUpdate.isNew = obj.get('new');
				}

				if (IS_VALID(obj.get('icon'))) {
					stateToUpdate.icon = {
						url: obj.get('icon').url(),
					};
				}

				actions.setValue(stateToUpdate);
			},
			customDelete: (obj) => {
				actions.setValue({
					showModal: true,
					formType: 'DELETE',
					formTitle: 'DELETE APP MENU',
					formId: obj.id,
					selectedData: obj,
				});
			},
			refreshTable: (refreshTable) => {
				this.refreshTableReference = refreshTable;
			},
			customItems: [
				{
					columnName: 'name',
					render: ({ value, column, getTableData, object }) => {
						let renderValue = '';

						if (IS_VALID(value)) {
							renderValue =
								value.substr(0, 100).trim() + (value.length <= 100 ? '' : '...');
						}

						return renderValue;
					},
				},
				{
					columnName: 'sort',
					render: ({ value, column, getTableData, object }) => {
						let renderValue = '';

						if (IS_VALID(object.get('sort'))) {
							renderValue = object.get('sort');
						}

						return renderValue;
					},
				},
			],
		};

		let formContainerProps = {
			actions,

			selectedData,
			formType,

			loadOptions: this.loadOptions,
			getRelation: this.getRelation,
			uploadSpecificUserCSVFile: this.uploadSpecificUserCSVFile,
		};

		let isActivateAccessible = this.accessible('ACTIVATE') === '',
			isDeactivateAccessible = this.accessible('DEACTIVATE') === '';

		return (
			<div>
				<Panel>
					<Panel.Heading
						style={{
							backgroundColor: '#D1282F',
							color: 'white',
						}}
					>
						<h4 style={{ display: 'inline-block' }}>App Menu</h4>
						<div style={{ float: 'right' }}>
							<Button
								style={
									(isActive ? !isDeactivateAccessible : !isActivateAccessible)
										? { cursor: 'not-allowed' }
										: null
								}
								bsStyle={isLoadingConfig ? null : isActive ? 'success' : 'danger'}
								disabled={
									isLoadingConfig ||
									(isActive ? !isDeactivateAccessible : !isActivateAccessible)
								}
								onClick={() => {
									if (
										isActive ? !isDeactivateAccessible : !isActivateAccessible
									) {
										return;
									}

									actions.setValue({
										showModalConfig: true,
									});
								}}
							>
								{isLoadingConfig ? (
									<i className="fa fa-spinner fa-spin" />
								) : isActive ? (
									'ACTIVE'
								) : (
									'INACTIVE'
								)}
							</Button>
						</div>
					</Panel.Heading>
					<Panel.Body>
						<CrudComponent {...crudProps} />
					</Panel.Body>
				</Panel>
				<Modal
					show={showModal}
					onHide={() => {
						if (!isLoadingAction) {
							actions.setValue({
								showModal: false,
							});
						}
					}}
				>
					<Modal.Header closeButton>
						<Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<FormContainer {...formContainerProps} />
					</Modal.Body>
					<Modal.Footer>{this.renderModalButton()}</Modal.Footer>
				</Modal>
				<Modal
					show={showModalConfig}
					onHide={() => {
						if (!isSavingConfig) {
							actions.setValue({
								showModalConfig: false,
							});
						}
					}}
					bsSize="small"
				>
					<Modal.Header closeButton>
						<h4>{isActive ? 'DEACTIVATE ' : 'ACTIVATE '}VOUCHER</h4>
					</Modal.Header>
					<Modal.Body>
						{`Are you sure you want to ${
							isActive ? 'deactivate' : 'activate'
						} App Block Message?`}
					</Modal.Body>
					<Modal.Footer>
						<Button
							bsStyle={isActive ? 'danger' : 'success'}
							disabled={isSavingConfig}
							onClick={() => this.saveAppMenuConfig()}
						>
							{isActive ? 'DEACTIVATE' : 'ACTIVATE'}
						</Button>
					</Modal.Footer>
				</Modal>
				<ToastContainer />
			</div>
		);
	}

	componentDidMount() {
		this.getAppMenuConfig();
	}
}

function mapStateToProps(state) {
	let { AppMenu, accessjson } = state;

	return {
		AppMenu,
		accessjson,
	};
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: (stateObject, actionType = SET_APP_MENU) =>
			generics.setValue(actionType, stateObject),
	};

	return {
		actions: bindActionCreators(actions, dispatch),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(AppMenu);



// WEBPACK FOOTER //
// ./components/AppMenu/index.js